import keyMirror from 'react-utils/keyMirror';
import { PageField, FieldTypes, FeedbackFieldTypes, QuestionnaireFields, RichTextFieldTypes, ImageType } from './FieldTypeMapping';

// @ts-expect-error assets
import checkboxImage from 'bender-url!ui-forms-components/img/properties/checkbox.png';
// @ts-expect-error assets
import datePickerImage from 'bender-url!ui-forms-components/img/properties/date-picker.png';
// @ts-expect-error assets
import dropDownImage from 'bender-url!ui-forms-components/img/properties/drop-down.png';
// @ts-expect-error assets
import fileUploadImage from 'bender-url!ui-forms-components/img/properties/file-upload.png';
// @ts-expect-error assets
import multiLineImage from 'bender-url!ui-forms-components/img/properties/multi-line.png';
// @ts-expect-error assets
import multipleCheckboxesImage from 'bender-url!ui-forms-components/img/properties/multiple-checkboxes.png';
// @ts-expect-error assets
import radioImage from 'bender-url!ui-forms-components/img/properties/radio.png';
// @ts-expect-error assets
import singleLineAlphaImage from 'bender-url!ui-forms-components/img/properties/single-line-alpha.png';
// @ts-expect-error assets
import singleLineNumberImage from 'bender-url!ui-forms-components/img/properties/single-line-number.png';
// @ts-expect-error assets
import ratingScaleImage from 'bender-url!ui-forms-components/img/properties/rating-scale.png';
// @ts-expect-error assets
import sliderScaleImage from 'bender-url!ui-forms-components/img/properties/slider-scale.png';
// @ts-expect-error assets
import starRatingImage from 'bender-url!ui-forms-components/img/properties/star-rating.png';
// @ts-expect-error assets
import matrixScaleImage from 'bender-url!ui-forms-components/img/properties/matrix-scale.png';
// @ts-expect-error assets
import emailIcon from 'bender-url!ui-forms-components/img/properties/email-icon.png';
// @ts-expect-error assets
import pageIcon from 'bender-url!ui-forms-components/img/properties/page.png';
// @ts-expect-error assets
import smileyIcon from 'bender-url!ui-forms-components/img/properties/smiley.png';
import * as FormFieldTypes from 'forms-utils-lib/fieldTypes/FormFieldTypes';
import { DividerIcon } from 'foundations-assets/icons/components/DividerIcon';
import { GaugeIcon } from 'foundations-assets/icons/components/GaugeIcon';
import { HeaderIcon } from 'foundations-assets/icons/components/HeaderIcon';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
import { RichTextIcon } from 'foundations-assets/icons/components/RichTextIcon';
export const NewFieldIconMapping = Object.freeze({
  [FieldTypes.NUMBER]: singleLineNumberImage,
  [FieldTypes.SINGLE_CHECKBOX]: checkboxImage,
  [FieldTypes.DATE]: datePickerImage,
  [FieldTypes.FILE]: fileUploadImage,
  [QuestionnaireFields.MATRIX_RATING]: matrixScaleImage,
  [QuestionnaireFields.STAR_RATING]: starRatingImage,
  [QuestionnaireFields.RANGE]: sliderScaleImage,
  [FeedbackFieldTypes.EMAIL]: emailIcon,
  [PageField]: pageIcon,
  [FormFieldTypes.STAR_RATING]: starRatingImage,
  [FormFieldTypes.RATING]: ratingScaleImage,
  [FormFieldTypes.SMILEY_RATING]: smileyIcon,
  [FormFieldTypes.RADIO]: radioImage,
  [FormFieldTypes.CHECKBOX]: multipleCheckboxesImage,
  [FormFieldTypes.SELECT]: dropDownImage,
  [FormFieldTypes.TEXT]: singleLineAlphaImage,
  [FormFieldTypes.TEXTAREA]: multiLineImage,
  [FormFieldTypes.HEADER]: 'header',
  [FormFieldTypes.PARAGRAPH]: 'richText',
  [FormFieldTypes.IMAGE]: 'insertImage',
  [FormFieldTypes.DIVIDER]: 'divider',
  [FormFieldTypes.NPS]: 'gauge',
  [FormFieldTypes.CSAT]: smileyIcon,
  [FormFieldTypes.CES]: ratingScaleImage
});
export const IconMapping = {
  [FormFieldTypes.HEADER]: HeaderIcon,
  [FormFieldTypes.PARAGRAPH]: RichTextIcon,
  [FormFieldTypes.IMAGE]: InsertImageIcon,
  [FormFieldTypes.DIVIDER]: DividerIcon,
  [FormFieldTypes.NPS]: GaugeIcon
};
export const fieldTypesWithIcon = keyMirror(Object.assign({}, RichTextFieldTypes, ImageType, {
  [FormFieldTypes.PHONE]: null,
  [FormFieldTypes.PHONE_NUMBER]: null
}));
export const isqFieldTypes = {
  [FormFieldTypes.NPS]: 'gauge'
};